// extracted by mini-css-extract-plugin
export default {"pinnedField":"FieldsSection-module__pinnedField--xRXo6","animationClass":"FieldsSection-module__animationClass--ZaRW4","colorFlash":"FieldsSection-module__colorFlash--IV0cL"};